<template lang="pug">
  input.autocomplete(
    :id='id'
    :name='name'
    type='text'
    ref='placeAutocomplete'
    :placeholder='placeholder'
    v-model='place' 
    @keyup='searchListener' 
    @blur='onBlur'
    v-validate='location')
</template>
<script>
/* eslint-disable no-undef */
import axios from 'axios'
import debounce from 'debounce'

export default {
  props: ['id', 'name', 'placeholder', 'value', 'source', 'validation'],
  inject: ['$validator'],
  data () {
    return {
      predictedPlaces: {},
      place: this.value,
      placesAutocomplete: null,
      searchListener: debounce(this.searchPlace, 1000),
      location: this.validation
    }
  },
  methods: {
    searchPlace () {
      this.predictedPlaces = {}
      if (!this.placesAutocomplete) {
        this.placesAutocomplete = this.$M.Autocomplete.init(this.$refs.placeAutocomplete, {
          onAutocomplete: (location) => {
            this.$emit('onLocationAutocomplete', location)
          }
        })
      }

      this.suggestPlace(this.place).then(places => {
        this.predictedPlaces = places
        this.placesAutocomplete.updateData(this.predictedPlaces)
        this.placesAutocomplete.open()
      })
    },
    suggestPlace (keyword) {
      const places = {}
      if (!keyword) {
        return Promise.resolve(places)
      }

      return this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        return axios
          .get(`${this.$config.API_URL}/config/places`, {
            headers: {
              authorization: `Bearer ${accessToken}`
            },
            params: {
              place: this.place,
              type: this.source
            }
          })
          .then(result => {
            for (let i = 0; i < result.data.data.length; i++) {
              places[result.data.data[i]] = null
            }

            return places
          })
      })
    },
    onBlur () {
      const places = Object.keys(this.predictedPlaces)
      if (places.length > 0) {
        this.place = places[0]
        this.$emit('onLocationAutocomplete', this.place)
      } else {
        this.$emit('onLocationAutocomplete', null)
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/input-place-autocomplete.vue